import { DexDispatcherFormEnumType } from '@mark43/cad-api';
import { WorkspacePanel } from '../../panels/workspace-panel';

export function getDataExchangeFormPanelMatcher({
    dexForm,
    dexNextEnabled,
}: {
    dexForm: DexDispatcherFormEnumType;
    dexNextEnabled: boolean;
}) {
    if (dexNextEnabled) {
        return (workspacePanel: WorkspacePanel): boolean =>
            workspacePanel.workspacePanelType === 'DATA_EXCHANGE_FORM';
    }

    return (workspacePanel: WorkspacePanel): boolean =>
        workspacePanel.workspacePanelType === 'DATA_EXCHANGE_FORM' &&
        workspacePanel.dexForm === dexForm;
}
